<template>
    <center-container>
        <v-radio-group v-model="selection">
            <v-radio
                v-for="selection in question.selections"
                :key="selection.uuid"
                :label="selection.title"
                :value="selection.uuid"
                hide-details
            ></v-radio>
        </v-radio-group>

        <skip-and-send-button
            @send="sendSelection"
            @skip="$emit('skip')"
            :disabled="selection == null"
        />
    </center-container>
</template>

<script>
import CenterContainer from "./CenterContainer.vue"
import SkipAndSendButton from "./SkipAndSendButton.vue"

export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    },

    components: {
        CenterContainer,
        SkipAndSendButton
    },

    data: () => ({
        selection: null
    }),

    methods: {
        sendSelection() {
            this.$emit('input', this.selection)
        }
    }
}
</script>
